import type { ChannelLinkTarget } from '../util/channelLink';

/**
 * Отложенный переход к каналу или статье по ссылке `/c/<адрес>[/p/<адрес статьи>]` (волна 2).
 *
 * <p>Та же схема и по той же причине, что у {@code pendingProfileBridge}: ссылку открывают в двух
 * состояниях, и оба обязаны сработать — приложение уже запущено (событие `url`) и приложение
 * поднимается с нуля (`getInitialURL`). Во втором случае адрес приходит раньше, чем смонтирован
 * список чатов, а у человека без аккаунта — ещё и раньше входа.
 *
 * <p>Отдельный буфер, а не общий с профилем: цели разные (открыть диалог против открыть статью), и
 * один буфер на двоих означал бы, что ссылка на канал, пришедшая следом за ссылкой на профиль,
 * молча вытесняет её.
 */

type Listener = (target: ChannelLinkTarget) => void;

let listener: Listener | null = null;
let pending: ChannelLinkTarget | null = null;

/** Канал из ссылки. Если открывать пока некому — ждёт подписчика (в том числе через вход). */
export function requestOpenChannelByLink(target: ChannelLinkTarget): void {
  if (listener) {
    listener(target);
    return;
  }
  pending = target;
}

export function subscribeOpenChannelByLink(fn: Listener): () => void {
  listener = fn;
  if (pending) {
    const t = pending;
    pending = null;
    fn(t);
  }
  return () => {
    if (listener === fn) listener = null;
  };
}
